import React, { useContext, useState, useEffect } from "react";
import { DragAndDropContext } from "../../../context/DragAndDropContext";
import { CustomElementsContext } from "../../../context/CustomElementsContext";
import ButtonPreview from "./ButtonPreview";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
//Assets
import ButtonSVG from "../../../assets/images/button.svg";
import ButtonSettings from "./ButtonSettings";
import RenameSVG from "../../../assets/images/rename.svg";
import * as UTILS from "../../../utils/Utils";
import navDots from "../../../assets/images/nav-dots.svg";
import Confirm from "../../Modal/Confirm";

export const CustomButtons = (props) => {
  const {
    customButtons,
    setCustomButtons,
    deleteCustomButton,
    getCustomButtons,
    setCustomButtonFilter,
  } = useContext(CustomElementsContext);
  const {onDrag, onDragEnd} = useContext(DragAndDropContext);
  const [buttons, setButtons] = useState(customButtons);
  const [selectedButton, setSelectedButton] = useState(null);

  useEffect(() => {
    setButtons(customButtons);
  }, [customButtons]);
  const filterButtons = (event) => {
    let buttonClone = JSON.parse(JSON.stringify(customButtons));
    buttonClone = buttonClone.filter((button) => {
      return (
        (button.custom_element_name &&
          button.custom_element_name.includes(event.target.value)) ||
        event.target.value === ""
      );
    });

    setButtons(buttonClone);
  };
  const editingNewButton = () => {
    const newButtonTool = JSON.parse(JSON.stringify(UTILS.tool[2]));
    setSelectedButton({
      custom_element_json: {
        ...newButtonTool,
        style: {
          ...newButtonTool.style,
          fontFamily: props.selectedFont.replace(/ /g, ""),
        },
      },
      custom_element_name: newButtonTool.customElementName,
      customElementID: newButtonTool.customElementID,
    });
  };

  const overrideCustomButton = (button) => {
    var layoutList = props.layoutList;
    const newButton = { ...button };

    const newLayoutList = UTILS.overrideAllOfElementType(
      layoutList,
      button.custom_element_json.customElementName,
      (item) => {
        (item.style = {
          ...newButton.custom_element_json.style,
        }),
          (item.mobileAlignment =
            newButton.custom_element_json.mobileAlignment),
          (item.customElementName =
            newButton.custom_element_json.customElementName),
          (item.normalBtn = {
            ...JSON.parse(JSON.stringify(newButton.custom_element_json.normalBtn)),
          }),
          (item.hoverBtn = {
            ...JSON.parse(JSON.stringify(newButton.custom_element_json.hoverBtn)),
          });
      },
      (item) => {
        (item.style = {
          ...newButton.custom_element_json.style,
        }),
          (item.mobileAlignment =
            newButton.custom_element_json.mobileAlignment),
          (item.customElementName =
            newButton.custom_element_json.customElementName),
          (item.normalBtn = {
            ...JSON.parse(
              JSON.stringify(newButton.custom_element_json.normalBtn)
            ),
          }),
          (item.hoverBtn = {
            ...JSON.parse(
              JSON.stringify(newButton.custom_element_json.hoverBtn)
            ),
          });
      },
      (item) => {
        (item.style = {
          ...newButton.custom_element_json.style,
        }),
          (item.mobileAlignment =
            newButton.custom_element_json.mobileAlignment),
          (item.customElementName =
            newButton.custom_element_json.customElementName),
          (item.normalBtn = {
            ...JSON.parse(
              JSON.stringify(newButton.custom_element_json.normalBtn)
            ),
          }),
          (item.hoverBtn = {
            ...JSON.parse(
              JSON.stringify(newButton.custom_element_json.hoverBtn)
            ),
          });
      }
    );
    
    // Actualizar el layout actual
    const currentLayoutItem = newLayoutList.find(
      (item) => item[0] === props.layoutTitle
    );
    if (currentLayoutItem) {
      props.layoutArray(props.layoutTitle, currentLayoutItem[1]);
    }
    
    props.layoutListArray(newLayoutList);
  };

  const overrideAllButtons = (button) => {
    var layoutList = props.layoutList;
    const newButton = { ...button };

    const newLayoutList = UTILS.overrideAllButtons(
      layoutList,
      (item) => {
        (item.style = {
          ...newButton.custom_element_json.style,
        }),
          (item.mobileAlignment =
            newButton.custom_element_json.mobileAlignment),
          (item.customElementName =
            newButton.custom_element_json.customElementName),
          (item.normalBtn = {
            ...JSON.parse(
              JSON.stringify(newButton.custom_element_json.normalBtn)
            ),
          }),
          (item.hoverBtn = {
            ...JSON.parse(
              JSON.stringify(newButton.custom_element_json.hoverBtn)
            ),
          });
      },
      (item) => {
        (item.style = {
          ...newButton.custom_element_json.style,
        }),
          (item.mobileAlignment =
            newButton.custom_element_json.mobileAlignment),
          (item.customElementName =
            newButton.custom_element_json.customElementName),
          (item.normalBtn = {
            ...JSON.parse(
              JSON.stringify(newButton.custom_element_json.normalBtn)
            ),
          }),
          (item.hoverBtn = {
            ...JSON.parse(
              JSON.stringify(newButton.custom_element_json.hoverBtn)
            ),
          });
      },
      (item) => {
        (item.style = {
          ...newButton.custom_element_json.style,
        }),
          (item.mobileAlignment =
            newButton.custom_element_json.mobileAlignment),
          (item.customElementName =
            newButton.custom_element_json.customElementName),
          (item.normalBtn = {
            ...JSON.parse(
              JSON.stringify(newButton.custom_element_json.normalBtn)
            ),
          }),
          (item.hoverBtn = {
            ...JSON.parse(
              JSON.stringify(newButton.custom_element_json.hoverBtn)
            ),
          });
      }
    );
    
    // Actualizar el layout actual
    const currentLayoutItem = newLayoutList.find(
      (item) => item[0] === props.layoutTitle
    );
    if (currentLayoutItem) {
      props.layoutArray(props.layoutTitle, currentLayoutItem[1]);
    }
    
    props.layoutListArray(newLayoutList);
  };
  const applyFilter = (filter) => {
    setCustomButtonFilter(filter);
    getCustomButtons("Button", filter);
  };
  return (
    <>
      <div className="custom-elements-container">
        <div className="custom-buttons-header">
          <img src={ButtonSVG} /> <p>Button({buttons.length}) </p>
          <button
            onClick={() => {
              editingNewButton();
            }}
            className="custom-element-plus"
          >
            +
          </button>
        </div>
        <input
          onChange={filterButtons}
          className=""
          placeholder="Search Custom Buttons"
          type="text"
        />
        <select
          defaultValue={"createdAt"}
          onChange={(e) => {
            applyFilter(e.target.value);
          }}
        >
          <option value="alphabetical">Alphabetical</option>
          <option value="createdAt">Created At</option>
          <option value="upgradedAt">Updated At</option>
        </select>

        <div className="custom-button-scroll-container">
          {buttons.map((button, index) => {
            return (
              <div
                key={"custom-button-" + index}
                draggable={true}
                onDragStart={(e) =>
                  onDrag(e, button.custom_element_json, {data:'toolbar',id:'toolbar'})
                }
                onDragEnd={onDragEnd}
                className="custom-elements-thumbnail"
              >
                <div className="drag-button-container">
                  <ButtonPreview button={button}></ButtonPreview>{" "}
                  <div className="drag-dots">
                    <img src={navDots} />
                  </div>
                </div>

                <div className="custom-elements-actions-container">
                  <div className="custom-elements-name">
                    {selectedButton == button
                      ? `${
                          button.customElementID == null
                            ? "Creating"
                            : "Editing"
                        } ${
                          button.custom_element_name !== null
                            ? button.custom_element_name
                            : "Undefined"
                        }...`
                      : `${
                          button.custom_element_name !== null
                            ? button.custom_element_name
                            : "Undefined"
                        }`}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",

                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        height: "25px",
                        position: "relative",
                      }}
                    >
                      <Confirm
                        title="Override Button Style"
                        confirmMessage={`Are you sure you want to override buttons designated as: ${button.custom_element_name}?`}
                        element="li"
                        classList="override-element-button"
                        getConfirmation={(status) => {
                          status && overrideCustomButton(button);
                        }}
                      ></Confirm>

                      <Confirm
                        title="Override ALL Buttons"
                        confirmMessage="Are you sure you want to override the style of all buttons in the microsite to this one?"
                        element="li"
                        classList="override-all-element-button"
                        getConfirmation={(status) => {
                          status && overrideAllButtons(button);
                        }}
                      ></Confirm>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        height: "25px",
                        position: "relative",
                      }}
                    >
                      <div
                        className="edit-custom-element-button"
                        onClick={() => {
                          setSelectedButton(button);
                        }}
                      ></div>
                      <Confirm
                        title="Delete Custom Element"
                        confirmMessage="Are you sure you want to delete this custom element?"
                        element="li"
                        classList="delete-element-button"
                        getConfirmation={(status) => {
                          status && deleteCustomButton(button);
                        }}
                      ></Confirm>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {selectedButton && (
        <ButtonSettings
          setSelectedButton={setSelectedButton}
          button={selectedButton}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
    layoutList: state.present.layoutList,
    canvasStyle: state.present.canvasStyle,
    elementsFont: state.present.canvasStyle.elementsFont,
    columnGap: state.present.canvasStyle.columnGap,
    rowGap: state.present.canvasStyle.rowGap,
    canvasRowsPaddingUnit: state.present.canvasStyle.canvasRowsPaddingUnit,
    enableWidthForRow: state.present.enableWidthForRow,
    canvasRowsPadding: state.present.canvasStyle.canvasRowsPadding,
    containerWidth: state.present.containerWidth,
    canvasRowsPaddingMobile: state.present.canvasStyle.canvasRowsPaddingMobile,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutListArray: (layoutList) =>
      dispatch(actionTypes.set_layout_list(layoutList)),
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CustomButtons);
